import React, { useContext } from "react";

import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Global, { saveReadedSale, saveUnreadedSales } from "../../util/Global";
import { useTranslation } from "react-i18next";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import OrderSaleDetail from "../../components/OrdersSales/OrderSaleDetail";
import NotFound from "../../components/NotFound";
import { CurrencyContext, filterSaleByRetailer } from "../../components/Utils";

const DetailVentes = () => {
  const { t } = useTranslation()
  const { id } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const [sale, setsale] = useState();
  const { showAlert } = useContext(AlertContext)
  const { getCurrencyPrice } = useContext(CurrencyContext)

  const { countUnreadedSales, setcountUnreadedSales, setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  const COMMANDE_DETAILS_URL = Global.backend + "/index.php/api/commande/show";


  useEffect(() => {
    setnavLinks([{ path: "/dashboard/user/mesventes", label: "mySales" }])
    setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
    setpageTitle("saleDetails")
    setalertTitle("")
  }, [])


  useEffect(() => {
    setisLoading(true)
    axios.post(COMMANDE_DETAILS_URL, {commandeId: id}).then((response) => {
        // mark as read
        if (response.data && saveReadedSale(id)) {
          setcountUnreadedSales(countUnreadedSales - 1)
          saveUnreadedSales(countUnreadedSales - 1)
        }


        if (response.data) {
          const sale = filterSaleByRetailer(response.data,getCurrencyPrice)

          if(sale.statut_commande=="refund"){
            setalertTitle(t("refundCustomerAlert"))
          }
          setsale(sale)
        }
      }).catch((err) => {
        showAlert("error", t("request.errorFetchSaleDetails"))
      })
      .finally(() => {
        setisLoading(false);
      });
  }, []);








  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading &&
        (!sale ? <NotFound /> : <OrderSaleDetail passedData={sale} isSale={true} />)
      }
    </LoaderComponent>
  );
};

export default DetailVentes;
